<template>
<div class="white-glove-balance">

  <div class="d-flex align-center gap10">
    <div>
      <div class="icon-area" style="padding: 10px;">
        <img src="/static/icon_crown_white.svg" />
      </div>
    </div>
    <div class="credit-status" style="flex: 1; font-weight: 600;">
      <div>
        {{ $store.getters.whiteGloveFamilyProgramName }} Program
      </div>
      <div style="font-weight: 800;">
        Balance: {{ formatCurrency(ownerUser.balance_cents / 100) }}
      </div>
    </div>
    <div>
      <v-btn
        x-small color="profileAnchorColor"
        class="button-with-icon whiteColor--text text-none"
        :disabled="$store.getters.isDemoUser"
        @click="$store.commit('setShowBalanceTopUpModal', true)"
      >
        <span>Top up</span>
      </v-btn>
    </div>
  </div>

</div>
</template>

<script>
import { formatCurrency } from '@/utils'

export default {
  props: [],
  components: {

  },
  data() {
    return {
      
    };
  },
  computed: {
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.$store.state.user
    },
  },
  methods: {
    formatCurrency: formatCurrency,
  },
  mounted () {

  }
};
</script>

<style lang="scss" scoped>

</style>
